export function toTitleCase(str) {
    // convert hello_world string to Hello World  
    let new_data = str
    new_data = str.split("_")
    let new_str = ""
    for(let i=0;i<new_data.length;i++){
        new_str = new_str+" "+new_data[i]
    }
    return new_str.replace(/\w\S*/g, function(txt){
        return txt.charAt(0).toUpperCase() + txt.substr(1).toUpperCase();
    });
}


export function getDifferenceInDays(date1, date2) {
    const diffInMs = Math.abs(date2 - date1);
    return parseInt(diffInMs / (1000 * 60 * 60 * 24));
}

export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}


export function createSlugfromName(str){
    let newstr = (str.toLowerCase()).split(/\W+/).join('-')
    if ( newstr.length > 0 && newstr[newstr.length - 1] === '-'){
        newstr = newstr.substring(0, newstr.length - 1);
    } 
        
    return newstr
  }

export const Dates = [
	{ 
		label: "Date",
		options: [
                { label: "1", value: '1' },
                { label: "2", value: '2' },
                { label: "3", value: '3' },
                { label: "4", value: '4' },
                { label: "5", value: '5' },
                { label: "6", value: '6' },
                { label: "7", value: '7' },
                { label: "8", value: '8' },
                { label: "9", value: '9' },
                { label: "10", value: '10' },
                { label: "11", value: '11' },
                { label: "12", value: '12' },
                { label: "13", value: '13' },
                { label: "14", value: '14' },
                { label: "15", value: '15' },
                { label: "16", value: '16' },
                { label: "17", value: '17' },
                { label: "18", value: '18' },
                { label: "19", value: '19' },
                { label: "20", value: '20' },
                { label: "21", value: '21' },
                { label: "22", value: '22' },
                { label: "23", value: '23' },
                { label: "24", value: '24' },
                { label: "25", value: '25' },
                { label: "26", value: '26' },
                { label: "27", value: '27' },
                { label: "28", value: '28' },
                { label: "29", value: '29' },
                { label: "30", value: '30' },
                { label: "31", value: '31' },
		]
	}
];

export const months_name = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
var months_options  = []
for (let m=0; m<months_name.length; m++ ){
  months_options.push({ label: months_name[m], value: m+1 })
}

export const Months = [
	{ 
		label: "Months",
		options: months_options
	}
];

// Function to convert degrees to radians
const deg2rad = (deg) => {
    return deg * (Math.PI / 180);
  };
  
  // Function to convert string representation of latitude and longitude to numerical values
  const stringToLatitudeLongitude = (latLongString) => {
    const parts = latLongString.split(/[°, ]/).filter(part => part !== "" && part !== "N" && part !== "E");
    const latitude = parseFloat(parts[0]);
    const longitude = parseFloat(parts[1]);
    return [latitude, longitude];
  };
  
  // Function to calculate distance between two coordinates
 export const calculateDistance = (latLongString1, latLongString2) => {
    const R = 6371; // Radius of the Earth in km
  
    const latLong1 = stringToLatitudeLongitude(latLongString1);
    const latLong2 = stringToLatitudeLongitude(latLongString2);
    
    if (!latLong1 || !latLong2) return null;
  
    const [lat1, lon1] = latLong1;
    const [lat2, lon2] = latLong2;
  
    // Convert latitude and longitude from degrees to radians
    const dLat = deg2rad(lat2 - lat1);
    const dLon = deg2rad(lon2 - lon1);
  
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  
    const d = (R * c)+40; // Distance in km
    
    return d.toFixed(2);
  };

  
// export const calculateDistance = (latLongString1, latLongString2 ) => {
//     const R = 6371; // Radius of the Earth in km

//     const latLong1 = stringToLatitudeLongitude(latLongString1)
//     const latLong2 = stringToLatitudeLongitude(latLongString2)
//     const lat1 = latLong1[0];
//     const lon1 = latLong1[1];
//     const lat2 = latLong2[0];
//     const lon2 = latLong2[1];

//     console.log(lat1, lon1, lat2, lon2, "Lat Long data ")

//     const dLat = deg2rad(lat2 - lat1);
//     const dLon = deg2rad(lon2 - lon1);

//     const a =
//       Math.sin(dLat / 2) * Math.sin(dLat / 2) +
//       Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);

//     const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

//     const d = R * c; // Distance in km

//     return d
//   };